<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .contact-info {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(4px);

    .name-and-linkedin {
      display: flex;
      align-items: center;
      gap: utils.in_rem(8px);

      .name {
        @include mixins.body2();
        @include colors.color(primary_90);
      }
    }

    .info-item {
      @include mixins.body3();
      @include colors.color(textLighterBlack);
    }
  }
</style>

<script>
  import SocialButton from "@sourcewhale/shared/svelte-design-system/components/atoms/SocialButton.svelte";

  let { resume } = $props();
</script>

<div class="contact-info">
  <div class="name-and-linkedin">
    <span class="name">{resume.name}</span>
    {#if resume.linkedinUrl}
      <SocialButton
        icon="fab fa-linkedin"
        color="primary_90"
        href={resume.linkedinUrl}
        size="xxs"
      />
    {/if}
  </div>
  <span class="info-item">{resume.role}</span>
  {#each resume.emails as email}
    <span class="info-item">{email}</span>
  {/each}
  {#each resume.phones as phones}
    <span class="info-item">{phones}</span>
  {/each}
</div>
